var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container", attrs: { "data-cy": "notifications-modal" } },
    [
      _c("h3", { staticClass: "title" }, [_vm._v("\n    Notificações\n  ")]),
      _vm._v(" "),
      _vm.loading
        ? _c("c-spinner", { staticClass: "loading" })
        : _vm.notifications.length > 0
        ? _c(
            "div",
            { staticClass: "content" },
            _vm._l(_vm.notifications, function(notification) {
              return _c("NotificationItem", {
                key: notification.id,
                attrs: { notification: notification },
                on: {
                  markAsRead: function($event) {
                    return _vm.markAsRead($event)
                  }
                }
              })
            }),
            1
          )
        : _c(
            "div",
            { staticClass: "content-empty" },
            [
              _c("c-character", { attrs: { type: "searching" } }),
              _vm._v(" "),
              _c("span", [_vm._v("Não há novas notificações")])
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e17469f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e17469f","hasScoped":true,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notifications/NotificationsList.vue
// module id = 2099
// module chunks = 1610